/** ч.843: дані віджетів головної сторінки (дні народження, борги, календар). */
import { api } from './client';

export interface BirthdayRow {
  individual_id: string; employee_id: string; organization_id: string;
  name: string; birth_date: string | null; position_name: string | null;
  date: string; in_days: number; turns_age: number | null;
}

export interface DebtSummary {
  kind: 'receivable' | 'payable';
  total: string; count: number;
  date_from: string | null; date_to: string | null;
  /** ч.1035: прострочено за накладними (розріз по документах, на сьогодні). */
  overdue: string; overdue_docs: number;
  top: { contractor_id: string; name: string; amount: string }[];
}

export interface TaxCalendarRow {
  date: string; title: string; kind: string; note: string;
  organization_id: string; organization_name: string;
}

export const dashboard = {
  birthdays: (params?: { organization_id?: string; days?: number; limit?: number }) =>
    api.get<{ items: BirthdayRow[] }>('/dashboard/birthdays', { params }).then((r) => r.data),
  debts: (params: { kind: 'receivable' | 'payable'; organization_id?: string;
    date_from?: string; date_to?: string; top?: number }) =>
    api.get<DebtSummary>('/dashboard/debts', { params }).then((r) => r.data),
  taxCalendar: (params?: { organization_id?: string; days?: number; limit?: number }) =>
    api.get<{ items: TaxCalendarRow[]; date_from: string; date_to: string }>(
      '/dashboard/tax-calendar', { params }).then((r) => r.data),
};
